import * as React from 'react';
import { SVGProps } from 'react';

const IconCommentEditFilledSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.001 12A.999.999 0 0 0 14 11V4a1 1 0 0 0-1-1H3c-.552 0-1 .444-1 .996V14l2.167-2H13ZM11 5.7l-.729.729-1.2-1.2L9.8 4.5 11 5.7Zm-2.271-.129 1.2 1.2L6.2 10.5H5V9.3l3.729-3.729Z"
    />
  </svg>
);
export default IconCommentEditFilledSizeS;
